<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>

    <!--신청 내역 팝업 -->
    <apply-donor-modal-comp
      :is-show.sync="isShowUserModal"
      ref="ApplyDonorModal"
    ></apply-donor-modal-comp>
    <div class="md-layout search-area">
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title"><md-icon>search</md-icon>검색 조건</h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th star>구분</th>
              <td colspan="3">
                <div class="inline-flex">
                  <label><input type="radio" value="" v-model="searchQuery.applyGb" name="applyGb">전체</label>
                  <label><input type="radio" value="1" v-model="searchQuery.applyGb" name="applyGb">개인명의</label>
                  <label><input type="radio" value="2" v-model="searchQuery.applyGb" name="applyGb">교우자녀</label>
                  <label><input type="radio" value="3" v-model="searchQuery.applyGb" name="applyGb">교우회(장학)</label>
                </div>
              </td>
              <th>대상학기</th>
              <td>
                <select v-model="searchQuery.semesterCd" name="semesterCd">
                  <option value="">선택</option>
                  <option v-for="item in semesterCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                    {{ item }}
                  </option>
                </select>
              </td>
              <th>기부자교우번호</th>
              <td>
                <input type="text" v-model="searchQuery.childMemberNo">
              </td>
              <th>기부자명</th>
              <td>
                <input type="text" v-model="searchQuery.childMemberNm">
              </td>
            </tr>
            <tr>
              <th>성명</th>
              <td><input type="text" v-model="searchQuery.nm"></td>
              <th>학번</th>
              <td><input type="text" v-model="searchQuery.hakbun"></td>
              <th star>지정여부</th>
              <td colspan="5">
                <div class="inline-flex">
                  <label><input type="radio" value="" v-model="searchQuery.matchingYn" name="matchingYn">전체</label>
                  <label><input type="radio" value="Y" v-model="searchQuery.matchingYn" name="matchingYn">Y</label>
                  <label><input type="radio" value="N" v-model="searchQuery.matchingYn" name="matchingYn">N</label>
                </div>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="sendQuery">
            <md-icon>check</md-icon>검 색
          </md-button>
          <md-button class="md-default md-sm" @click="resetQuery">
            <md-icon>clear</md-icon>초기화
          </md-button>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
          <md-button class="md-success md-sm" @click="updateApplyMemberNo">
            <md-icon>check</md-icon>교우번호매핑
          </md-button>
        </md-card-actions>
      </md-card>

      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>
            검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <grid ref="scholarshipMappingGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @dblclick="onDbClickExecutive"
                @response="response"></grid>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>


<script>

import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import Swal from "sweetalert2";
import ApplyDonorModalComp from "@/pages/Scholarship/Components/ApplyDonorModalComp";

export default {
  name: "scholarshipMappingGrid",

  components: {
    grid: Grid,
    ApplyDonorModalComp
  },

  created() {
    this.getSemesterCdList();
    this.getClgSemesterCdList();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  data() {
    return {
      isShowUserModal: false,
      searchQuery : {
        applyGb : '',
        semesterCd : '',
        childMemberNo : null,
        childMemberNm : null,
        nm : null,
        hakbun : null,
        matchingYn : ''
      },
      semesterCdList : [],
      clgSemesterCdList : [],
      checkedClgSemesterCdList : [],
      gridProps: {},
      pagination: {
        perPage: 500,
        page: 1,
        perPageOptions: [800, 500, 200, 100, 50, 20],
        total: 0
      },
      orgData: null
    };
  },
  methods: {
    getSemesterCdList() {
      kuaaFnc.fncSemesterCodes(null, res => {
        this.semesterCdList = res.data.data.contents;
        this.searchQuery.semesterCd = this.semesterCdList[0]?.code;
      });
    },
    getClgSemesterCdList() {
      kuaaFnc.fncClgSemesterCdList(null, res => {
        this.clgSemesterCdList = res.data.data.contents;
      });
    },
    resetQuery() {
      this.selectAll = false;
      this.searchQuery = {
        applyGb : '',
        semesterCd : this.semesterCdList[0]?.code,
        childMemberNo : null,
        childMemberNm : null,
        nm : null,
        hakbun : null,
        matchingYn : ''
      }
    },
    sendQuery() {
      this.$refs.scholarshipMappingGrid.invoke("readData", this.$refs.scholarshipMappingGrid.invoke("getPagination")._currentPage, this.searchQuery);
    },

    initGrid() {
      let _this = this;
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_SCHA_APPLY_LIST2, false, this.pagination);
      this.gridProps['el'] = this.$refs.scholarshipMappingGrid;
      this.gridProps['columns']= [
        {header: '대상학기', name: 'semesterCdNm', align: 'center', sortable: true},
        {header: '신청구분', name: 'applyGbNm', align: 'center', sortable: true},
        {header: '교우번호', name: 'memberNo', align: 'center', sortable: true,
          formatter: function (value) { 
            return `<span style="color:#0091d5; cursor:pointer">${value.value}</span>`;
          }
    },
        {header: '교우성명', name: 'memberHnm', align: 'center', sortable: true},
        {header: '교우대학', name: 'collegeNm', align: 'center', sortable: true},
        {header: '교우학과', name: 'classNm', align: 'center', sortable: true},
        {header: '교우학번', name: 'hakbun', align: 'center', sortable: true},
        {header: '신청자대학(학부)', name: 'collegeMCdNm', align: 'center', width:120, sortable: true},
        {header: '신청자학과(학부)', name: 'collegeSCdNm', align: 'center', width:120, sortable: true},
        {header: '신청자학년', name: 'collegeSemesterCdNm', align: 'center', sortable: true},
        {header: '신청자학번', name: 'tsaHakbun', align: 'center', sortable: true},
        {header: '신청자성명', name: 'nm', align: 'center', sortable: true,
          formatter: function (value) { 
            return `<span style="color:#0091d5; cursor:pointer">${value.value}</span>`;
          }
        },
        {header: '지급조건', name: 'conditionGive', align: 'center', sortable: true},
        {header: '세부조건', name: 'conditionDetail', align: 'center', sortable: true},
        {header: '비고', name: 'conditionEtc', sortable: true},
        {header: '담당부서(교내포함)', name: 'recomPart', align: 'center', width:130, sortable: true},
        {header: '학장', name: 'recomDean', align: 'center', sortable: true},
        {header: '부장(차장)', name: 'recomDirector', align: 'center', sortable: true},
        {header: '담당자', name: 'recomManager', align: 'center', sortable: true},
        {header: '전전', name: 'prev2AvgHakjum', align: 'center', sortable: true},
        {header: '직전', name: 'prevAvgHakjum', align: 'center', sortable: true},
        {header: '평균', name: 'avgHakjum', align: 'center', sortable: true},
        {header: '1학년1학기', name: 'schShipNm11', width:200, sortable: true},
        {header: '1학년2학기', name: 'schShipNm12', width:200, sortable: true},
        {header: '2학년1학기', name: 'schShipNm21', width:200, sortable: true},
        {header: '2학년2학기', name: 'schShipNm22', width:200, sortable: true},
        {header: '3학년1학기', name: 'schShipNm31', width:200, sortable: true},
        {header: '3학년2학기', name: 'schShipNm32', width:200, sortable: true},
        {header: '4학년1학기', name: 'schShipNm41', width:200, sortable: true},
        {header: '4학년2학기', name: 'schShipNm42', width:200, sortable: true},
        {header: '5학년1학기', name: 'schShipNm51', width:200, sortable: true},
        {header: '5학년2학기', name: 'schShipNm52', width:200, sortable: true},
        {header: '과세증명', name: 'propertyTaxCdNm', align: 'center', sortable: true},
        {header: '납입액', name: 'healthInsuCdNm', align: 'right', sortable: true,
          formatter(value) {return value.value ? formatter.getCurrency(value.value) : null;},
        },
        {header: '소득합계', name: 'propertyYearlyCdNm', align: 'right', sortable: true,
          formatter(value) {return value.value ? formatter.getCurrency(value.value) : null;},
        },
        {header: '환산점수표', name: 'pointTotal', align : 'right', sortable: true,
          formatter(value) {
            let tempArr = new Array('A','B','C','D','E','F','G','H','N');
            let total = 0;
            tempArr.forEach((t)=>{
              total += Number(value.row[t]);
            })
            return formatter.getCurrency(total);
          }
        },
        {header: '비고', name: 'noteEtc', align: 'center'},
        {header: '구분', name: 'giveGbNm', align: 'center', width:130, sortable: true},
        {header: '교우회구분', name: 'kuaa2ndInfoGb', align: 'center', sortable: true},
        {header: '교우회금액', name: 'kuaaAmount', align: 'right', sortable: true,
          formatter(value) {return value.value ? formatter.getCurrency(value.value) : null;},
        },
        {header: '장학회구분', name: 'scha2ndInfoGb', align: 'center', sortable: true},
        {header: '장학회금액', name: 'schaAmount', align: 'right', sortable: true,
          formatter(value) {return value.value ? formatter.getCurrency(value.value) : null;},
        },
        {header: '보전액', name: 'reserveAmount', align: 'right', sortable: true,
          formatter(value) {return value.value ? formatter.getCurrency(value.value) : null;},
        },
        {header: '합계', name: 'total', align : 'right', sortable: true,
          formatter(value) {return value.value ? formatter.getCurrency(value.value) : null;}
        },
        {header: 'A', name: 'A', align : 'center', hidden:true},
        {header: 'B', name: 'B', align : 'center', hidden:true},
        {header: 'C', name: 'C', align : 'center', hidden:true},
        {header: 'D', name: 'D', align : 'center', hidden:true},
        {header: 'E', name: 'E', align : 'center', hidden:true},
        {header: 'F', name: 'F', align : 'center', hidden:true},
        {header: 'G', name: 'G', align : 'center', hidden:true},
        {header: 'H', name: 'H', align : 'center', hidden:true},
        {header: 'N', name: 'N', align : 'center', hidden:true}
      ];
      this.gridProps['columnOptions'].frozenCount = 7;
      this.gridProps['columnOptions'].minWidth = 100;

    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(
        this.$refs.scholarshipMappingGrid,
        event,
        this.pagination
      );
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if (res.result) {
        this.pagination.total = res.data.pagination.totalCount;
      } else {
        kuaaFnc.gridErrorCallback(e);
      }
      //this.$refs.scholarshipMappingGrid.invoke("refreshLayout");
    },

    // onClickRow(e){
    //   if(e.columnName == 'applyEtc' || e.columnName == 'fileDir'){

    //   }else if(e.columnName == 'nm'){
    //     if(e.instance.getRow(e.rowKey) != null) {
    //       this.$emit('returnResult', e.instance.getRow(e.rowKey));
    //     }
    //   }
    // },

    onDbClickExecutive(e) {
      //
      console.log (e.instance.getRow(e.rowKey).tsaHakbun);
      if (e.columnName === "memberNo" && e.instance.getRow(e.rowKey) != null) {
        window.open(
          // "/Friendship/UpdateMember/" + e.instance.getRow(e.rowKey).memberNo,
          // "FriendshipUpdateMember"
          "/Scholarship/DonatorManagement?semesterCd=" +
            e.instance.getRow(e.rowKey).semesterCd +
            "&memberNo=" +
            e.instance.getRow(e.rowKey).memberNo,
          "DonatorManagement"
        );
      } else if (e.columnName === "nm" && e.instance.getRow(e.rowKey) != null) {
        // this.$refs.ApplyDonorModal.setData(e.instance.getRow(e.rowKey));
        // this.isShowUserModal = true;
        window.open(
          "/Scholarship/ApplicantList?semesterCd=" +
            e.instance.getRow(e.rowKey).semesterCd +
            "&nm=" +
            e.instance.getRow(e.rowKey).nm,
          "ApplicantList"
        );
      }
    },

    downloadExcel() {
      this.searchQuery.page = 1;
      this.searchQuery.perPage = this.pagination.total;
      this.searchQuery.fileName = '장학매칭관리';
      kuaaApi.requestFileDownload(
          URL_CONST.SCHA_APPLY_MAPPING_EXCEL_DOWNLOAD2,
          this.searchQuery,
          '장학매칭관리.xlsx',
          response => {

          }
      );
    },

    updateApplyMemberNo(){
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "졸업생(장학금 수혜자)의 교우번호를 매핑 처리합니다.<br>진행 하시겠습니까?",
      });
      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.UPDATE_SCHA_APPLY_MEMBER_NO,
            {},
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `매핑처리 되었습니다 [ ${response.data.data}건 ]`;
                Swal.fire(modalOptions);
                if(this.pagination.total !== 0) this.sendQuery();
              } else {
                modalOptions.html = `매핑 처리에 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    }
  }
};
</script>

<style>

</style>